import {
  REQUEST_ALL_PLANS, RECEIVE_ALL_PLANS, REQUEST_PLANS, RECEIVE_PLANS, REQUEST_PLAN, RECEIVE_PLAN, REQUEST_SAVE_PLAN,
  RECEIVE_SAVE_PLAN, RESET_PLAN, RESET_ALL_PLAN
} from '../constants/ActionTypes'

const INITIAL_STATE = {
  all: {
    isLoading: false,
    data: {
      rows: [],
    },
  },
  list: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
  item: {
    isLoading: false,
    data: {},
    receivedAt: null,
  },
  save: {
    isLoading: false,
  },
}

export default function PlanReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_ALL_PLANS:
      return {
        ...state,
        all: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.all.data,
        }
      }
    case RECEIVE_ALL_PLANS:
      return {
        ...state,
        all: {
          isLoading: action.isLoading,
          data: action.data || INITIAL_STATE.all.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_PLANS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.list.data,
        }
      }
    case RECEIVE_PLANS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_PLAN:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.item.data,
        }
      }
    case RECEIVE_PLAN:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_SAVE_PLAN:
    case RECEIVE_SAVE_PLAN:
      return {
        ...state,
        save: {
          isLoading: action.isLoading,
        }
      }
    case RESET_PLAN:
      return {
        ...state,
        item: INITIAL_STATE.item,
      }
    case RESET_ALL_PLAN:
      return INITIAL_STATE
    default:
      return state
  }
}
